<div class="flex flex-col gap-3 h-full" >
  <div class="grow-default grid grid-cols-13 gap-1 sm:gap-3 px-4">
    <ng-container  *ngIf="!isLoading">
      <div class="col-span-13 flex items-center justify-center max-h-[210px]  lg:max-h-[240px] xxl:max-h-[260px] xxxl:max-h-[270px] xxxxl:max-h-[300px] xxxxxl:max-h-[350px] xxxxxxl:max-h-[380px]" >
        <canvas
        baseChart
        [labels]="chartLabels"
        [datasets]="doughnutChartDatasets"
        [options]="doughnutChartOptions"
        [legend]="false"
        [type]="doughnutChartType"
        [plugins]="doughnutChartPlugins"
        > </canvas>
      </div>

      <!-- <div class="col-span-4 flex flex-col justify-center items-start gap-5 xxl:pl-1 lg:-ml-2 xxl:ml-0">
        <div class="flex gap-1 xxl:gap-2  items-center text-no-wrap  whitespace-nowrap overflow-hidden text-ellipsis w-full" *ngFor="let percentage of chartData; index as i">
          <ion-icon name="ellipse" class="text-xs sm:text-sm xl:text-base min-w-[12px] sm:min-w-[14px] xl:min-w-[16px] left-4"  [ngStyle]="{'color': originalChartColors[i]}"></ion-icon>
          <p class="text-xxs sm:text-xs xxl:text-sm xxxl:text-base"><span class="font-bold">{{percentage}}</span></p>
          <p class="text-xxs sm:text-xs xxl:text-sm xxxl:text-base whitespace-nowrap overflow-hidden text-ellipsis">{{chartLabels[i]}}</p>
        </div>
      </div> -->
    </ng-container>

    <div  *ngIf="isLoading" class="w-full col-span-13 flex items-center justify-center max-h-[210px]  lg:max-h-[240px] xxl:max-h-[260px] xxxl:max-h-[270px] xxxxl:max-h-[300px] xxxxxl:max-h-[350px] xxxxxxl:max-h-[380px] m-auto">
      <!-- <div class="w-full"> -->
        <ion-skeleton-text [animated]="true" class="w-full h-[140px] xxl:h-[150px] rounded-lg"></ion-skeleton-text>
      <!-- </div> -->

    </div>
  </div>
</div>
